import defaultState from './defaultState'

export default {
  setCustomFields(state, payload) {
    state.customFields = payload
  },
  addCustomField(state, payload) {
    state.customFields.push(payload)
  },
  addSectionToList(state, payload) {
    state.sectionsList.push(payload)
  },
  deleteSectionFromList(state, slug) {
    const index = state.sectionsList.findIndex((section) => section.slug === slug)
    state.sectionsList.splice(index, 1)
  },
  updateSectionFromList(state, payload) {
    const index = state.sectionsList.findIndex((section) => section.slug === payload.slug)
    const updatedSectionsList = [...state.sectionsList]
    updatedSectionsList[index] = { ...updatedSectionsList[index], ...payload }
    state.sectionsList = updatedSectionsList
  },
  setSectionList(state, payload) {
    state.sectionsList = payload
  },
  reorderCustomFields(state, payload) {
    payload.forEach((slugWithPosition) => {
      const field = state.customFields.find((field) => field.slug === slugWithPosition.slug)
      if (field) {
        field.position = slugWithPosition.position
      }
    })
  },
  reorderObjectCustomField(state, payload) {
    const object = state.customFields.find((field) => field.slug === payload.slug)
    payload.fields.forEach((field) => {
      const foundedField = object.objectConfiguration
        .find((configurationField) => configurationField.name === field.name)

      if (foundedField) {
        foundedField.position = field.position
      }
    })
  },
  updateCustomField(state, payload) {
    const clonedCustomFields = [...state.customFields]
    const index = state.customFields.findIndex((field) => field.slug === payload.slug)
    if (index !== -1) {
      clonedCustomFields[index] = payload
    }
    state.customFields = clonedCustomFields
  },
  deleteCustomField(state, slug) {
    const index = state.customFields.findIndex(field => field.slug === slug)
    if (index !== -1) {
      state.customFields.splice(index, 1)
    }
  },
  deleteChildObject(state, payload) {
    const fieldIndex = state.customFields.findIndex((field) => field.slug === payload.fieldSlug)

    if (fieldIndex === -1) {
      return
    }

    const field = state.customFields[fieldIndex]

    const indexToDelete = field.objectConfiguration.findIndex((object) => object.name === payload.columnName)

    if (indexToDelete === -1) {
      return
    }

    const updatedObjectConfiguration = [...field.objectConfiguration]
    updatedObjectConfiguration.splice(indexToDelete, 1)

    const updatedField = {
      ...field,
      objectConfiguration: updatedObjectConfiguration,
    }

    const updatedCustomFields = [...state.customFields]
    updatedCustomFields[fieldIndex] = updatedField

    state.customFields = updatedCustomFields
  },
  setFunctionsConfigurations(state, payload) {
    state.functionsConfigurations = payload
  },
  reset(state) {
    Object.assign(state, defaultState())
  },
  setEntitiesCondition(state, payload) {
    state.entitiesConditions = payload
  },
  addEntityConditions(state, payload) {
    state.entitiesConditions.push(payload)
  },
  updateEntityConditions(state, payload) {
    const clonedEntitiesConditions = [...state.entitiesConditions]
    const index = state.entitiesConditions.findIndex((item) => item.entitySlug === payload.entitySlug)
    if (index !== -1) {
      clonedEntitiesConditions[index] = payload
    }
    state.entitiesConditions = clonedEntitiesConditions
  },
  deleteEntityConditions(state, id) {
    const index = state.entitiesConditions.findIndex((item) => item.id === id)
    state.entitiesConditions.splice(index, 1)
  },
}
